'use client';

import { useQuery } from '@tanstack/react-query';
import { QueryKeys } from 'mode-shared/constants/queryKeys';
import axios, { AxiosResponse } from 'axios';
import localConfig from 'mode-shared/configs/config';
import { useAccount } from 'wagmi';
import { UserPromptsCount } from './types';
import { getFromLocalStorage, removeFromLocalStorage } from 'mode-shared/utils/localStorage';
import { AxiosError } from 'axios';

const getUserPromptsCount = async (address?: `0x${string}`) => {
  const signature = getFromLocalStorage<string>('signature');

  if (!signature) {
    console.error('getUserPromptsCount: No signature found');
    throw new Error('No signature found');
  }

  if (!address) {
    console.error('getUserPromptsCount: No wallet address provided');
    throw new Error('No wallet address provided');
  }

  try {
    const { data: user } = await axios.get<void, AxiosResponse<UserPromptsCount | undefined>>(
      `${localConfig.apiUrl}/ai-terminal/users/${address}/message-count`,
      {
        headers: {
          Authorization: signature,
        },
      }
    );

    return user;
  } catch (error) {
    console.error(error);
    if (error instanceof AxiosError) {
      if (error.response?.data === 'invalid signature') {
        removeFromLocalStorage('signature');
      }
    }
  }
};

export const useGetUserPromptsCount = (options = {}) => {
  const { address } = useAccount();

  return useQuery<UserPromptsCount | undefined>({
    queryKey: [QueryKeys.USER_PROMPTS_COUNT, address],
    queryFn: async () => {
      return await getUserPromptsCount(address);
    },
    enabled: !!address,
    ...options,
  });
};
